const globalImageSelector = (state) => {
  return state.assets.globalImages;
};

const templateImageSelector = (state) => {
  return state.assets.templateImages;
};

const templateIconSelector = (state) => {
  return state.assets.templateIcons;
};

const unsplashSelector = (state) => {
  return state.assets.unsplash;
};

const iconFinderSelector = (state) => {
  return state.assets.iconFinder;
};

const foldersSelector = (state) => {
  return state.assets.folders;
};

export {
  globalImageSelector,
  templateImageSelector,
  templateIconSelector,
  unsplashSelector,
  iconFinderSelector,
  foldersSelector,
};
